/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LegalBypassReason } from './';
import {
    LegalBypassReasonFromJSON,
    LegalBypassReasonFromJSONTyped,
    LegalBypassReasonToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateFreelancerLegalBypassRequest
 */
export interface CreateFreelancerLegalBypassRequest {
    /**
     * The client team ID (24 character MongoDB ObjectId)
     * @type {string}
     * @memberof CreateFreelancerLegalBypassRequest
     */
    clientTeamId: string;
    /**
     * 
     * @type {LegalBypassReason}
     * @memberof CreateFreelancerLegalBypassRequest
     */
    bypassReason: LegalBypassReason;
    /**
     * Additional comment (required when bypassReason is OTHER)
     * @type {string}
     * @memberof CreateFreelancerLegalBypassRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the CreateFreelancerLegalBypassRequest interface.
 */
export function instanceOfCreateFreelancerLegalBypassRequest(value: object): value is CreateFreelancerLegalBypassRequest {
    if (!('clientTeamId' in value) || value['clientTeamId'] === undefined) return false;
    if (!('bypassReason' in value) || value['bypassReason'] === undefined) return false;
    return true;
}

export function CreateFreelancerLegalBypassRequestFromJSON(json: any): CreateFreelancerLegalBypassRequest {
    return CreateFreelancerLegalBypassRequestFromJSONTyped(json, false);
}

export function CreateFreelancerLegalBypassRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFreelancerLegalBypassRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientTeamId': json['clientTeamId'],
        'bypassReason': LegalBypassReasonFromJSON(json['bypassReason']),
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function CreateFreelancerLegalBypassRequestToJSON(value?: CreateFreelancerLegalBypassRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientTeamId': value['clientTeamId'],
        'bypassReason': LegalBypassReasonToJSON(value['bypassReason']),
        'comment': value['comment'],
    };
}

